import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NOB from '../../../../constants/language-strings';
import styled, { css } from 'styled-components';
import { purpurColorFunctionalWhite, purpurColorGray100, purpurColorGreen600, purpurColorRed600, } from '@purpurds/tokens/color/variables';
import spacing from 'theme/spacing';
import { purpurShadowMd } from '@purpurds/tokens/shadow/variables';
const HealthCheckListItem = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 300;
  font-size: 18px;
  background-color: ${purpurColorFunctionalWhite};
  margin-bottom: ${spacing.spacing2};
  padding-left: ${spacing.spacing16};
  height: 30px;
  box-shadow: ${purpurShadowMd};
  border: 1px solid ${purpurColorGray100};
`;
const HealthCheckListItemStatus = styled.div `
  width: 47px;
  margin-right: ${spacing.spacing16};
`;
const dot = (color) => css `
  width: 10px;
  height: 10px;
  background-color: ${color};
  border-radius: 50%;
  display: inline-block;
`;
const StatusOK = styled.div `
  ${dot(purpurColorGreen600)};
  margin-right: ${spacing.spacing4};
`;
const StatusError = styled.div `
  ${dot(purpurColorRed600)};
  margin-right: ${spacing.spacing4};
`;
export const ListItem = ({ passed, description }) => (_jsxs(HealthCheckListItem, { children: [description, passed ? (_jsxs(HealthCheckListItemStatus, { children: [_jsx(StatusOK, {}), NOB.HEALTH_CHECK.STATUS_OK] })) : (_jsxs(HealthCheckListItemStatus, { children: [_jsx(StatusError, {}), NOB.HEALTH_CHECK.STATUS_ERROR] }))] }));
